const IconTrashcan = ({ size, color, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M12.0938 2.9375H10.043L9.11328 1.40625C8.86719 0.996094 8.45703 0.75 7.99219 0.75H5.23047C4.76562 0.75 4.35547 0.996094 4.10938 1.40625L3.17969 2.9375H1.12891C0.773438 2.9375 0.5 3.23828 0.5 3.59375C0.5 3.92188 0.773438 4.25 1.12891 4.25H1.375L1.94922 13.5195C1.97656 14.2305 2.55078 14.75 3.26172 14.75H9.96094C10.6719 14.75 11.2461 14.2305 11.2734 13.5195L11.875 4.25H12.0938C12.4492 4.25 12.75 3.97656 12.75 3.59375C12.75 3.23828 12.4492 2.9375 12.0938 2.9375ZM5.23047 2.0625H7.99219L8.51172 2.9375H4.71094L5.23047 2.0625ZM9.96094 13.4375H3.26172L2.6875 4.25H10.5352L9.96094 13.4375Z"
            fill={color}
        />
    </svg>
);

export default IconTrashcan;
